import { API_ROUTES } from '@/constants/apiRoutes';
import { IdempotentRequest } from '@/types/common';
import {
  DeclineExternalAccountForm,
  ExternalAccountFormValues,
  ExternalAccountDetails,
  ExternalAccountsListResponse,
} from '@/types/externalAccounts';
import { api } from '@/utils/api';

export const getExternalAccountListService = async (queryParams: string) => {
  const { data } = await api<ExternalAccountsListResponse>({
    url: `${API_ROUTES.EXTERNAL_ACCOUNTS}?${queryParams}`,
    method: 'get',
    version: 2,
  });

  return data;
};

export const getExternalAccountDetailsService = async (id: string) => {
  const { data } = await api<ExternalAccountDetails>({
    url: `${API_ROUTES.EXTERNAL_ACCOUNTS}${id}`,
    method: 'get',
    version: 2,
  });

  return data;
};

export const addExternalAccountService = async (
  payload: IdempotentRequest<ExternalAccountFormValues>,
) => {
  const { data } = await api<string>({
    url: API_ROUTES.EXTERNAL_ACCOUNTS,
    method: 'post',
    version: 2,
    data: {
      account_name: payload.ownerName,
      account_type: payload.accountType,
      bank_name: payload.bankName,
      account_number: payload.accountNumber,
      routing_number: payload.routingNumber,
      bank_address: {
        line1: payload.bankAddress.line1,
        line2: payload.bankAddress.line2,
        postal_code: payload.bankAddress.postalCode,
        state: payload.bankAddress.state,
        city: payload.bankAddress.city,
      },
      owner_id: payload.customerId,
      physical_address: {
        line1: payload.ownerAddress.line1,
        line2: payload.ownerAddress.line2,
        postal_code: payload.ownerAddress.postalCode,
        state: payload.ownerAddress.state,
        city: payload.ownerAddress.city,
      },
      supports_wire_transfers:
        payload.paymentType === 'wire' || payload.paymentType === 'both',
      supports_ach_transfers:
        payload.paymentType === 'ach' || payload.paymentType === 'both',
      bank_account_application_id: payload.bankAccountApplicationId || null,
      proofs_of_ownership: payload.proofsOfOwnership.map(proof => proof.value),
    },
    idempotencyKey: payload.idempotencyKey,
  });

  return data;
};

export const deleteExternalAccountService = async (id: string) => {
  const { status } = await api({
    url: `${API_ROUTES.EXTERNAL_ACCOUNTS}${id}`,
    method: 'delete',
    version: 2,
  });

  return status;
};

export const declineExternalAccountService = async (
  data: DeclineExternalAccountForm,
) => {
  const { status } = await api({
    url: `${API_ROUTES.EXTERNAL_ACCOUNTS}${data.id}`,
    method: 'post',
    version: 2,
    data: { reason_to_decline: data.reason },
  });

  return status;
};

export const approveExternalAccountService = async (id: string) => {
  const { status } = await api({
    url: `${API_ROUTES.EXTERNAL_ACCOUNTS}${id}/verify`,
    method: 'post',
    version: 2,
  });

  return status;
};
